var a={};export{a as default};
//# sourceMappingURL=_node-resolve_empty.js.map
